import { render, staticRenderFns } from "./Pagebottomtext.vue?vue&type=template&id=51221f52&scoped=true&"
var script = {}
import style0 from "./Pagebottomtext.vue?vue&type=style&index=0&id=51221f52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51221f52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/ubq-h5_build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51221f52')) {
      api.createRecord('51221f52', component.options)
    } else {
      api.reload('51221f52', component.options)
    }
    module.hot.accept("./Pagebottomtext.vue?vue&type=template&id=51221f52&scoped=true&", function () {
      api.rerender('51221f52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pagebottomtext.vue"
export default component.exports